<template>
  <section
    class="cloudflare-turnstile-3f-style"
    role="group"
    aria-label="CAPTCHA-verifikation"
  >
    <div ref="container" class="cf-turnstile"></div>
  </section>
</template>

<script>
export default {
  props: {
    sitekey: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      default: "light",
      validator: value => ["light", "dark", "auto"].includes(value)
    },
    size: {
      type: String,
      default: "flexible",
      validator: value => ["normal", "compact", "flexible"].includes(value)
    },
    language: {
      type: String,
      default: "da"
    }
  },
  data() {
    return {
      widgetId: null,
      observer: null
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting && this.widgetId === null) {
          this.observer.disconnect();
          this.loadScript().then(() => {
            this.renderWidget();
          });
        }
      },
      { threshold: 0 }
    );
    this.observer.observe(this.$el);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.widgetId !== null && window.turnstile) {
      window.turnstile.remove(this.widgetId);
    }
  },
  methods: {
    loadScript() {
      return new Promise(resolve => {
        if (window.turnstile) {
          resolve();
          return;
        }

        if (window.__turnstileLoading) {
          const interval = setInterval(() => {
            if (window.turnstile) {
              clearInterval(interval);
              resolve();
            }
          }, 50);
          return;
        }

        window.__turnstileLoading = true;
        const script = document.createElement("script");
        script.src =
          "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
        script.async = true;
        script.onload = () => {
          const interval = setInterval(() => {
            if (window.turnstile) {
              clearInterval(interval);
              resolve();
            }
          }, 10);
        };
        script.onerror = () => {
          this.$emit("error", new Error("Failed to load Turnstile script"));
        };
        document.head.appendChild(script);
      });
    },
    renderWidget() {
      if (!this.$refs.container || !window.turnstile) return;

      this.widgetId = window.turnstile.render(this.$refs.container, {
        sitekey: this.sitekey,
        theme: this.theme,
        size: this.size,
        language: this.language,
        callback: token => {
          this.$emit("verify", token);
        },
        "error-callback": error => {
          this.$emit("error", error);
        },
        "expired-callback": () => {
          this.$emit("expired");
        }
      });
    },
    reset() {
      if (this.widgetId !== null && window.turnstile) {
        window.turnstile.reset(this.widgetId);
      }
    },
    getResponse() {
      if (this.widgetId !== null && window.turnstile) {
        return window.turnstile.getResponse(this.widgetId);
      }
      return null;
    }
  }
};
</script>

<style lang="scss">
@import "../../sass/component.scss";

.cloudflare-turnstile-3f-style {
  overflow: hidden;
  border-radius: 10px;
  height: 65px !important;
  border-inline: 9px solid theme-color("light");
  .cf-turnstile {
    overflow: hidden;
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    transform: scale(1.03);
    background-color: theme-color("light");
  }
}
</style>
